import {useGetAndSet} from "./useGetAndSet";
import {createSetExistingJobData} from "../actions/dataActions";

export const useExistingJobData = (params, dataFresh, noFetch) => {
    return useGetAndSet("existingjobs", params, createSetExistingJobData, dataFresh, noFetch);
}